import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-process-list',
  templateUrl: './process-list.component.html',
  styleUrls: ['./process-list.component.scss']
})
export class ProcessListComponent implements OnInit, OnDestroy {
  custId: string = '';
  breadCrumbItems: Array<{}> = [];
  private destroy$ = new Subject<void>();
  searchTerm: string = '';
  submitted: boolean = false;
  action: string = '';
  errmsg: string = '';
  processData: any[] = [];

  currentPage = 1;
  itemsPerPage = 5;
  pageSize = 0;

  delprocessId: any = '';
  selectedProcess: any = null;

  processName: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private dataservice: DataService,
    private toastr: ToastrService
  ) {
    this.custId = this.route.snapshot.paramMap.get('id') || '';
  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'Configuration' },
      { label: 'Process' },
      { label: 'Process', active: true },
    ];
    this.getData();
  }

  getData(): void {
    this.dataservice
      .get(`api/process?custId=${this.custId}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: any) => {
          this.processData = res
          this.resetToValidPage(); // FIX: adjust page after data loads
        },
        (err) => {
          this.toastr.error('Server Unreachable');
          this.errmsg = 'Failed to load processes.';
        }
      );
  }

  // FIX: If current page is now beyond total pages (e.g. after delete),
  // jump back to the last valid page so items are always visible.
  resetToValidPage(): void {
    const totalPages = Math.ceil(this.processData.length / this.itemsPerPage);
    if (this.currentPage > totalPages && totalPages > 0) {
      this.currentPage = totalPages;
    } else if (totalPages === 0) {
      this.currentPage = 1;
    }
    this.pageSize = this.itemsPerPage * (this.currentPage - 1);
  }

  goBack(): void {
    this.router.navigate(['/device', { id: this.custId }]);
  }

  openModal(content: any, data: any, act: string): void {
    this.action = act;
    this.submitted = false;

    if (act === 'Edit' && data) {
      this.selectedProcess = data;
      this.processName = data.processName;
    } else {
      this.selectedProcess = null;
      this.processName = '';
    }

    this.modalService.open(content, { backdrop: 'static', centered: true, size: 'sm' });
  }

  // FIX: pageSize must be recalculated based on the new page number
  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }

  openModalDelete(deletetemp: any, data: any): void {
    this.delprocessId = data.processId;
    this.modalService.open(deletetemp, { backdrop: 'static', centered: true });
  }

  saveprocess(): void {
    this.submitted = true;
    if (!this.processName || !this.processName.trim()) return;

    if (this.action === 'Add') {
      const payload = {
        processName: this.processName.trim(),
        custId: this.custId,
      };
      this.dataservice.post('api/process', payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          () => {
            this.toastr.success('Process added successfully');
            this.modalService.dismissAll();
            this.getData();
          },
          (err) => this.toastr.error(err.message)
        );
    } else if (this.action === 'Edit') {
      const payload = {
        processName: this.processName.trim(),
        custId: this.custId,
        processId: this.selectedProcess.processId
      };
      this.dataservice.put(`api/process`, payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          () => {
            this.toastr.success('Process updated successfully');
            this.modalService.dismissAll();
            this.getData();
          },
          (err) => this.toastr.error(err.message)
        );
    }
  }

  delete(id: any): void {
    this.dataservice
      .delete(`api/process?custId=${this.custId}&processId=${id}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
          this.toastr.success('Process deleted successfully');
          this.modalService.dismissAll();
          this.getData();
        },
        (err) => this.toastr.error(err.message)
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}